export class PushNotification {
  id: number;
  title: string;
  body: string;
  imageUrl: string;
  targetApp: string;
  targetAudience: string;
  targetId: number;
  sendType: string;
  scheduledAt: string;
  recurrence: string;
  recurrenceEnd: string;
  status: string;
  sentAt: string;
  sentCount: number;
  failedCount: number;
  createdBy: number;
  createdAt: string;
  updatedAt: string;
  Admin: any;
  PushLogs: any[];

  constructor() {
    this.targetApp = 'both';
    this.targetAudience = 'all';
    this.sendType = 'immediate';
    this.recurrence = 'none';
    this.status = 'draft';
    this.sentCount = 0;
    this.failedCount = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/push-notification.ts